import React from 'react';
import SettingsCard from '../../organisms/SettingsCard';
import Stepper from '../../organisms/Stepper';
import TableCardGrid from '../../organisms/TableCardGrid';
import { useSettingsWizard } from '../../../context/SettingsWizardContext';
import {
  DEMO_DEPARTMENTS_TREE,
  SETTINGS_STEPS,
} from '../../../data/settingsSteps';

export default function WorkflowStep({
  onNext,
  stepMeta,
  stepperProps,
}) {
  const { state, update, updateWorkflow } = useSettingsWizard();
  const { selectedDeptNode, workflow } = state;

  return (
    <>
      {/* Main wizard stepper */}
      <Stepper {...stepperProps} steps={SETTINGS_STEPS} />

      <SettingsCard
        title={stepMeta.title}
        description={stepMeta.description}
        showNext={false}
      >
     

          {/* Workflow Table Grid */}
          <div className="ca-workflow__main">
            <TableCardGrid
              initialTables={workflow.steps}
              onChange={(steps) =>
                updateWorkflow({ steps })
              }
            />
          </div>
        {/* </div> */}
      </SettingsCard>
    </>
  );
}